import { formatApiDateRangeDisplay } from '#/utils/date';

/**
 * UI range DatePicker ↔ listQuery.filters（API：`receipt_date_from`／`receipt_date_to`）。
 */
export function readReceiptDateRangeFilter(filters = {}) {
  const from = filters.receiptDateFrom;
  const to = filters.receiptDateTo;

  if (!from && !to) {
    return undefined;
  }

  return {
    from: from ?? '',
    to: to ?? from ?? '',
  };
}

export function applyReceiptDateRangeToFilters(filters = {}, range) {
  const next = { ...filters };

  if (!range?.from && !range?.to) {
    delete next.receiptDateFrom;
    delete next.receiptDateTo;
    return next;
  }

  const from = range.from;
  const to = range.to || range.from;

  next.receiptDateFrom = from || undefined;
  next.receiptDateTo = to || undefined;

  return next;
}

export function resolveReceiptDateFilterChipDisplay(_values, ctx = {}) {
  const display = formatApiDateRangeDisplay({
    from: ctx.filters?.receiptDateFrom,
    to: ctx.filters?.receiptDateTo,
  });

  return display ? [display] : [];
}
